import React, {useContext, useLayoutEffect, useState} from 'react';
import {ScrollView, Platform} from 'react-native';
import {Promo, User} from '../../../../generated/smg_service_pb';
import MainStyle from '../../../../MainStyle';
import {StoreContext} from '../../../components/StoreContextProvider';
import {LANDING_PAGE_URL, SESSION_EXPIRE_TIME} from '../../../constants';
import ServiceClient from '../../../utils/ServiceClient';
import AsyncStorage from '@react-native-async-storage/async-storage';
import moment from 'moment';
import {useNavigation} from "@react-navigation/native";
import BottomNavigation from '../../../components/BottomNavigation';
import NewHeader from "../../../components/NewHeader";
import Button from '../../../components/Button';
import Div from '../../../lib/Div';
import PromoCard from './components/PromoCard';
import AddNewPromoCode from './components/AddNewPromoCode';
import P from "../../../lib/P";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";

const PromosScreen = () => {
  const Context = useContext(StoreContext);
  const {user, cancelModalConfig} = Context;
  const [promos, setPromos] = useState<Promo[]>([]);
  const navigation: NativeStackNavigationProp<any> = useNavigation();
  const [isOpenAddNewPromo, setIsOpenAddNewPromo] = useState(false)

  const getPromos = (userId: number) => {
    Context.setLoadingOverlay(true);

    ServiceClient.getPromos(userId).then(res => {
      Context.setLoadingOverlay(false);
      setPromos(res);

    }).catch(err => {
      Context.setLoadingOverlay(false);
      Context.setCancelModalConfig({
        visible: true, subtitle: err.message || 'Request Promos Error', title: 'Error', leftBtnText: 'OK',
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
          navigation.navigate({name: 'account', params: {step: 1}});
        }
      });
    });
  };

  useLayoutEffect(() => {
    if (!user) {
      (async () => {
        const time = await AsyncStorage.getItem('lastActiveTime');

        if (time && moment().diff(moment(time), 'minutes') > SESSION_EXPIRE_TIME) {
          Context.logout().then(() => {
            if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
            Context.setLoadingOverlay(false);
          });

        } else {
          const val = await AsyncStorage.getItem('session');
          let curUser: User | undefined;

          if (val) {
            const Session = JSON.parse(val);
            Context.setSession(Session);

            try {
              curUser = await Context.getUser(Session);

            } catch (e: any) {
              Context.setCancelModalConfig({
                visible: true, title: 'Error', subtitle: e?.message || 'Error', rightBtnText: 'OK',
                onResume: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
              });
            }
          }

          if (!val || !curUser || !curUser.userId) {
            Context.logout().then(() => {
              if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
              Context.setLoadingOverlay(false);
            });

          } else getPromos(Number(curUser.userId));
        }
      })();

    } else getPromos(Number(user.userId));
  }, []);

  return (
    <>
      <ScrollView contentContainerStyle={MainStyle.min_h_full}>
        <NewHeader pb={11}/>

        <Div px={21}>
          <P fw="500" fs={30} lh={24} mb={16}>Promos</P>

          <Button
            text="Add Promo Code" mb={17} w={350} mx="auto" onPress={() => setIsOpenAddNewPromo(true)}
            textStyle={MainStyle.Barlow600}
          />

          <P ta="center" fw="500" fs={18} mb={16}>{'SELECT A PROMO TO SEE ITS\nTERM AND CONDITIONS'}</P>
        </Div>

        <Div px={5} alignItems="center">
          {!!promos.length && promos.map((promo, i) => (
            <PromoCard key={promo.id.toString() + i} data={promo}/>
          ))}
        </Div>
      </ScrollView>

      <Div alignItems="center" maxW={1125} mx="auto" w="100%">
        <BottomNavigation page="promos"/>
      </Div>

      <AddNewPromoCode isOpen={isOpenAddNewPromo} onClose={() => setIsOpenAddNewPromo(false)}/>
    </>
  );
};

export default PromosScreen;
